﻿import { gsap, CSSPlugin, CustomEase,  CustomWiggle } from 'gsap/all';

export class Navigation {
    constructor() {
        gsap.registerPlugin(CustomEase, CustomWiggle);
        const top = document.querySelector("#nav-line-top");
        const mid = document.querySelector("#nav-line-middle");
        const bottom = document.querySelector("#nav-line-bottom");
       
        CustomWiggle.create("navWiggleIn", {
            wiggles: 3,
            type: "easeIn"
        });
        CustomWiggle.create("navWiggleOut", {
            wiggles: 3,
            type: "easeOut"
        });
        let hoverTl = gsap.timeline();

      
            hoverTl.to(top, {
                duration: .25,
                ease: "navWiggleIn",
                transformOrigin: "center",
                rotation: 5
            }, 0);
            hoverTl.to(mid, {
                duration: .25,
                ease: "navWiggleIn",
                transformOrigin: "center",
                rotation: -5
            }, 0);
            hoverTl.to(bottom, {
                duration: .25,
                ease: "navWiggleIn",
                transformOrigin: "center",
                rotation: 5
            }, 0);

            hoverTl.to(top, {
                duration: .25,
                ease: "navWiggleOut",
                transformOrigin: "center",
                rotation: 0
            }, .25);
            hoverTl.to(mid, {
                duration: .25,
                ease: "navWiggleOut",
                transformOrigin: "center",
                rotation: 0
            }, .25);
            hoverTl.to(bottom, {
                duration: .25,
                ease: "navWiggleOut",
                transformOrigin: "center",
                rotation: 0
            }, .25);

      
        if (window.innerWidth >= 768) {
            document.querySelector(".menu-open.main").addEventListener("mouseover", (e) => {

                hoverTl.restart();

            });

        }
        const closeLeft = document.querySelector("#nav-close-left");
        const closeRight = document.querySelector("#nav-close-right");

        let hoverClose = gsap.timeline();
        hoverClose.to(closeLeft, {
            duration: .25,
            ease: "navWiggleIn",
            transformOrigin: "center",
            rotation: 5
        }, 0);
        hoverClose.to(closeRight, {
            duration: .25,
            ease: "navWiggleIn",
            transformOrigin: "center",
            rotation: -5
        }, 0);

        hoverClose.to(closeLeft, {
            duration: .25,
            ease: "navWiggleOut",
            transformOrigin: "center",
            rotation: 0
        }, .25);
        hoverClose.to(closeRight, {
            duration: .25,
            ease: "navWiggleOut",
            transformOrigin: "center",
            rotation: 0
        }, .25);


        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                if (document.querySelector("body.nav-open")) {
                    document.querySelector(".menu-open").click();
                }
            }
        });

        document.querySelector(".menu-open.second").addEventListener("mouseover", (e) => {
            hoverClose.restart();
        });

        document.querySelector("#navCurtain").addEventListener("click", (e) => {

            document.querySelector(".menu-open").click();
        });

        document.querySelectorAll(".menu-open").forEach((item) => {


            item.addEventListener("click", (e) => {
                if (document.querySelector("body").classList.contains("nav-open")) {


                    const closeBtn = document.querySelector(".menu-open .close");
                    const openBtn = document.querySelector(".menu-open .open");
                    const subMenu = document.querySelector("#subMenu");
                    const curtain = document.querySelector("#navCurtain");

                    

                    //gsap.set(closeBtn, { duration: .5, autoAlpha: 0 });
                    //gsap.to(openBtn, { duration: .5, autoAlpha: 1 });
                    //gsap.set(subMenu, { duration: .5, autoAlpha: 0 });

                    let navAnim = gsap.timeline({
                        onComplete: () => {
                            curtain.style.display = "none";
                            subMenu.style.display = "none";
                        }
                    });
                    const subMenuWidth = getComputedStyle(subMenu).width;
                    navAnim.to(subMenu, { duration: .5, x: subMenuWidth });
                    navAnim.to(curtain, { duration: .5, opacity: 0 }, 0);
                    
                    document.querySelector("#announce").innerHTML = "<p>Main Menu closed</p>";

                    document.querySelector("body").classList.remove("nav-open");
                    window.dispatchEvent(new CustomEvent("scrollStart", { bubbles: true, cancelable: true  }));
                   
                } else {
                    const closeBtn = document.querySelector(".menu-open .close");
                    const openBtn = document.querySelector(".menu-open .open");
                    const curtain = document.querySelector("#navCurtain");
                    const subMenu = document.querySelector("#subMenu");
                    subMenu.style.display = "block";


                    let navAnim = gsap.timeline();
                    curtain.style.display = "block";
                    curtain.style.opacity = "0";

                    gsap.set(".sub-menu-inner a", { opacity: 0, scale: 1.1 });


                    navAnim.to(subMenu, { duration: .5, x: 0 });
                    navAnim.to(curtain, { duration: .5, opacity: .25 }, 0);
                    navAnim.to(".sub-menu-inner a", { duration: .25, opacity: 1, scale: 1, stagger: { amount: .2 }, });
                    //gsap.set(closeBtn, { duration: .5, autoAlpha: 1 });
                    //gsap.set(openBtn, { duration: .5, autoAlpha: 0 });
                    //gsap.set(subMenu, { duration: .5, autoAlpha: 1 });

                    document.querySelector("body").classList.add("nav-open");
                    window.dispatchEvent(new CustomEvent("scrollStop", { bubbles: true, cancelable: true }));
                    document.querySelector("#announce").innerHTML = "<p>Main Menu opened. Press escape to close.</p>";
                }

            })
        });


    }
}